// https://codepen.io/natonischuk/pen/QbGWBa?editors=0100

import { css } from 'styled-components';
import { detect } from '../../utils/detect-browser';
const unsupported = ['opera-mini', 'ie', 'firefox'];

const multiLineElipsis = (lineHeight, lineCount, backgroundColor) => {
    const browser = detect().name;
    return unsupported.some(b => b === browser)
        ? cssHack(lineHeight, lineCount, backgroundColor)
        : lineClamp(lineCount);
};

const cssHack = (lineHeight = 1, lineCount = 3, backgroundColor = 'white') => css`
    overflow: hidden;
    position: relative;
    line-height: ${lineHeight}em;
    max-height: ${lineHeight * lineCount}em;
    text-align: justify;
    margin-right: -1em;
    padding-right: 1em;
    &:before {
        content: '...';
        position: absolute;
        background: ${backgroundColor};
        right: 1em;
        padding-left: 0.25em;
        padding-top: 0.25em;
        bottom: 0;
    }
    &:after {
        content: '';
        position: absolute;
        right: 0;
        width: 2em;
        height: 1em;
        margin-top: 0.2em;
        background: ${backgroundColor};
    }
`;

const lineClamp = lineCount =>
    `overflow: hidden;
     display: -webkit-box;
     -webkit-line-clamp: ${lineCount};
     -webkit-box-orient: vertical;`;

export const styledScrollbar = color => css`
    &::-webkit-scrollbar {
        width: 4px;
        border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: ${color || '#ff245e'};
    }
`;

export default multiLineElipsis;
